import { useGlobalQuery } from '@/state/query-client/hooks';
import { getHrTermsOfUsers, getLeaveCalendarData } from '../services/leave-calendar.service';
import { GetLeaveCalendarParams } from '../types/leave-calendar.types';

export const useGetLeaveCalendarData = (params: GetLeaveCalendarParams) => {
  return useGlobalQuery({
    queryKey: ['hr-leave-calendar', params],
    queryFn: () => getLeaveCalendarData(params),
    staleTime: 60 * 1000,
  });
};

/** The HR terms (work days) of the people shown, to shade each one's own weekend. */
export const useGetHrTermsOfUsers = (userIds: string[]) => {
  const ids = [...userIds].sort();
  return useGlobalQuery({
    queryKey: ['hr-leave-calendar-hr-terms', ids],
    queryFn: () => getHrTermsOfUsers(ids),
    enabled: ids.length > 0,
    staleTime: 10 * 60 * 1000,
  });
};
